import {
  VITE_APIGEE_BASE_URL,
  VITE_APIGEE_PROVISION_API_BASE_URL,
} from './envConstants';

/**** Proxy Base paths *****/
const APIGEE_WALLET_PROXY_CONTEXT_PATH =
  '/v1/credit/digital-payment-token-account-lookup';
const APIGEE_PROVISION_PROXY_CONTEXT_PATH = '/v1/credit/accounts/wallets';
const APIGEE_OMNI_APPLY_INTERNAL_PROXY_CONTEXT_PATH =
  '/v1/internal/credit/apply/omni/application';

/**** Digital Payment Token Account Lookup Services proxy context paths *****/
export const SESSION_CONTEXT = '/session';
export const ACCOUNT_LIST_CONTEXT = '/accounts';
export const PAYMENT_TOKEN_CONTEXT = '/payment-token';
export const REFRESH_CONTEXT = '/refresh';
export const LOGOUT_CONTEXT = '/logout';
export const D2D_CONTEXT = '/token';

/**** Account Management (Credit limit increase) Proxy context path *****/
export const CREDIT_LIMIT_INCREASE_CONTEXT =
  '/v1/credit/accounts/management/credit-limit-increase';

/**** Provision proxy context path *****/
const PROVISION_CONTEXT = '/provision';

/**** Full API endpoint URLs *****/
export const ACCOUNT_LIST_ENDPOINT = `${VITE_APIGEE_BASE_URL}${APIGEE_WALLET_PROXY_CONTEXT_PATH}${ACCOUNT_LIST_CONTEXT}`;
export const PAYMENT_TOKEN_ENDPOINT = `${VITE_APIGEE_BASE_URL}${APIGEE_WALLET_PROXY_CONTEXT_PATH}${PAYMENT_TOKEN_CONTEXT}`;
export const REFRESH_ENDPOINT = `${VITE_APIGEE_BASE_URL}${APIGEE_WALLET_PROXY_CONTEXT_PATH}${REFRESH_CONTEXT}`;
export const LOGOUT_ENDPOINT = `${VITE_APIGEE_BASE_URL}${APIGEE_WALLET_PROXY_CONTEXT_PATH}${LOGOUT_CONTEXT}`;
export const SESSION_ENDPOINT = `${VITE_APIGEE_BASE_URL}${APIGEE_WALLET_PROXY_CONTEXT_PATH}${SESSION_CONTEXT}`;
export const PROVISION_API_ENDPOINT = `${VITE_APIGEE_PROVISION_API_BASE_URL}${APIGEE_PROVISION_PROXY_CONTEXT_PATH}${PROVISION_CONTEXT}`;
export const CREDIT_LIMIT_INCREASE_ENDPOINT = `${VITE_APIGEE_BASE_URL}${CREDIT_LIMIT_INCREASE_CONTEXT}`;
export const D2D_ENDPOINT = `${VITE_APIGEE_BASE_URL}${APIGEE_OMNI_APPLY_INTERNAL_PROXY_CONTEXT_PATH}`;

/**** API Header Param keys start *****/
export const X_SYF_ID_TOKEN = 'X-SYF-Id-Token';
export const X_SYF_MERCHANT_ID = 'X-SYF-Merchant-Id';

/**** API ciphered account id payload param *****/
export const CIPHER_ACCOUNT_ID = 'cipher.accountId';
